/*********************************************
 * Product gallery
 *********************************************/
(function () {
    const mq = window.matchMedia('(max-width: 767px)');
    const galleries = [];

    /* build the flickity sliders for one gallery, only while the mobile layout is visible */
    function init(wrapper) {
        const sliderEl = wrapper.querySelector('.sp-product-media__main');
        if (!sliderEl || wrapper._spSlider) return;

        const slider = new Flickity(sliderEl, {
            contain: true,
            prevNextButtons: false,
            wrapAround: true,
            fade: true,
            pageDots: false,
            percentPosition: true,
            dragThreshold: 10,
            selectedAttraction: 0.2,
            friction: 0.8,
        });
        wrapper._spSlider = slider;

        const thumbsEl = wrapper.querySelector('.sp-product-media__thumbs');
        if (thumbsEl) {
            wrapper._spThumbs = new Flickity(thumbsEl, {
                asNavFor: sliderEl,
                contain: true,
                pageDots: false,
                prevNextButtons: false,
                cellAlign: 'left',
                freeScroll: true,
                wrapAround: false,
                dragThreshold: 6,
            });
        }

        requestAnimationFrame(() => {
            slider.resize();
            if (wrapper._spThumbs) wrapper._spThumbs.resize();
        });
    }

    /* tear down the sliders when leaving the mobile layout */
    function destroy(wrapper) {
        if (wrapper._spThumbs) wrapper._spThumbs.destroy();
        if (wrapper._spSlider) wrapper._spSlider.destroy();
        wrapper._spThumbs = wrapper._spSlider = null;
    }

    function sync() {
        galleries.forEach(mq.matches ? init : destroy);
    }

    document.querySelectorAll('.sp-product-media').forEach(wrapper => galleries.push(wrapper));
    if (!galleries.length) return;

    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else mq.addListener(sync);

    // iOS reports a wrong size right after rotation, so resize once it settles
    window.addEventListener('orientationchange', () => {
        setTimeout(() => galleries.forEach(w => {
            if (w._spSlider) w._spSlider.resize();
            if (w._spThumbs) w._spThumbs.resize();
        }), 300);
    });

    let synthetic = false;
    document.addEventListener('click', (e) => { if (synthetic) e.preventDefault(); }, true); // never let the hidden desktop link open a new tab

    /* open the same PhotoSwipe popup as desktop by clicking the matching hidden desktop link */
    document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-sp-lightbox]');
        if (!link || !mq.matches) return;
        e.preventDefault();
        const wrapper = link.closest('.sp-product-media');
        const mediaId = link.closest('[data-media-id]').dataset.mediaId;
        const prev = wrapper.previousElementSibling;
        const root = prev && prev.tagName === 'PRODUCT-MEDIA' ? prev : document;
        const target = root.querySelector('.swiper-slide:not(.swiper-slide-duplicate)[data-media-id="' + mediaId + '"] a[data-main-media-link]');
        if (!target) return;
        let attempts = 0;
        const open = () => { // the lightbox script may still be loading, so retry until pswp opens
            if (window.pswp) return;
            synthetic = true;
            target.click();
            synthetic = false;
            if (!window.pswp && ++attempts < 40) setTimeout(open, 100);
        };
        open();

        let tries = 0;
        const bind = () => { // pswp is exposed on window while the popup is open
            const pswp = window.pswp;
            if (!pswp) {
                if (++tries < 300) requestAnimationFrame(bind);
                return;
            }
            pswp.options.imageClickAction = false;
            pswp.options.tapAction = false;
            pswp.options.doubleTapAction = false;
            pswp.on('change', () => {
                if (wrapper._spSlider) wrapper._spSlider.select(pswp.currIndex, false, true);
            });
        };
        bind();
    });
})();
